<template>
    <div class="Page" v-if="State">
        <Header :Act="State"></Header>
        <div class="MaxWid">
            <div class="MarTop">
                <div class="AboutPos" @click="Back">当前位置：{{State==5?'继续教育':State==6?'信息动态':'职业伦理'}}</div>
            </div>
            <div class="Cont" v-if="Data">
                <!-- 继续/学历教育项目详情（与个人中心一致） -->
                <template v-if="isProjectDetail">
                    <div class="title">{{Data.title || Data.name}}</div>
                    <div class="ContDis">
                        <div class="Flex">项目类型：{{getProjectTypeText(Data.project_type)}}</div>
                        <div class="Flex">状态：{{Data.status_text || '-'}}</div>
                    </div>
                    <div class="project-section">
                        <div class="section-title">项目基础信息</div>
                        <div class="info-grid">
                            <div class="info-item">
                                <div class="label">开始时间</div>
                                <div class="value">{{Data.start_date || '-'}}</div>
                            </div>
                            <div class="info-item">
                                <div class="label">结束时间</div>
                                <div class="value">{{Data.end_date || '-'}}</div>
                            </div>
                            <div class="info-item">
                                <div class="label">项目课时</div>
                                <div class="value">{{Data.total_hours || '-'}}</div>
                            </div>
                            <div class="info-item">
                                <div class="label">目标学员</div>
                                <div class="value">{{Data.target_students || '-'}}</div>
                            </div>
                            <div class="info-item">
                                <div class="label">预期人数</div>
                                <div class="value">{{Data.expected_students || '-'}}</div>
                            </div>
                            <div class="info-item">
                                <div class="label">收费标准</div>
                                <div class="value">{{Data.fee || '-'}}</div>
                            </div>
                            <div class="info-item">
                                <div class="label">项目可行性</div>
                                <div class="value">{{Data.feasibility || '-'}}</div>
                            </div>
                        </div>
                        <div class="info-block" v-if="Data.synopsis">
                            <div class="label">项目介绍</div>
                            <div class="value">{{Data.synopsis}}</div>
                        </div>
                        <div class="info-block" v-if="Data.img">
                            <div class="label">相关文件</div>
                            <div class="value file-link" @click="OpenLock(Data.img)">点击查看</div>
                        </div>
                        <div class="info-block" v-if="Data.content">
                            <div class="label">详细内容</div>
                            <div class="value" v-html="Data.content"></div>
                        </div>
                    </div>

                    <div class="project-section" v-if="Array.isArray(Data.course) && Data.course.length">
                        <div class="section-title">课程信息</div>
                        <el-table :data="Data.course" border style="width: 100%">
                            <el-table-column prop="course_module" label="课程模块" width="180"></el-table-column>
                            <el-table-column prop="teaching_objective" label="教学目标" width="180"></el-table-column>
                            <el-table-column prop="content" label="课程内容" width="200"></el-table-column>
                            <el-table-column prop="teacher" label="讲师" width="120"></el-table-column>
                            <el-table-column prop="hours" label="课时" width="120"></el-table-column>
                            <el-table-column prop="remark" label="备注"></el-table-column>
                        </el-table>
                    </div>

                    <div class="project-section" v-if="Array.isArray(Data.teachers) && Data.teachers.length">
                        <div class="section-title">师资信息</div>
                        <el-table :data="Data.teachers" border style="width: 100%">
                            <el-table-column prop="name" label="姓名" width="180"></el-table-column>
                            <el-table-column prop="title" label="职称" width="180"></el-table-column>
                            <el-table-column prop="company" label="所属单位" width="180"></el-table-column>
                            <el-table-column prop="specialty" label="专业领域" width="180"></el-table-column>
                            <el-table-column prop="remark" label="备注"></el-table-column>
                        </el-table>
                    </div>

                    <div class="project-section" v-if="experienceFiles.length">
                        <div class="section-title">过往相似项目经验</div>
                        <div class="experience-files">
                            <div class="experience-file" v-for="(file, idx) in experienceFiles" :key="idx">
                                <img class="LockImg" :src="$Global.CommImgHttp + file" alt="" @click="OpenLock(file)">
                            </div>
                        </div>
                    </div>
                </template>

                <!-- 原信息/公告详情展示 -->
                <template v-else>
                    <div class="title">{{Data.title || Data.name}}</div>
                    <div class="ContDis">
                        <div class="Flex">发布时间：{{formatTime(Data.updatetime)}}</div>
                        <div class="Flex">状态：{{Data.status_text || '-'}}</div>
                    </div>
                    <div class="ContHead" v-html="Data.content"></div>
                </template>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/header/head';
    import Footer from '@/components/header/footer';
    import wenjianImg1 from '@/assets/img/1.jpg';
    import wenjianImg2 from '@/assets/img/2e.jpg';
    import wenjianImg3 from '@/assets/img/99192c03a738bde8ed15518370924b71.jpg';
    export default {
        components: {Header,Footer},
        data() {
            return {
                Data:"",
                State:"",
                isStaticWenjian: false,
            }
        },
        mounted() {
            // 如果是静态文件页 /wenjian，则使用固定内容
            if (this.$route && this.$route.path === '/wenjian') {
                this.isStaticWenjian = true;
                this.State = 6; // 6 对应"信息动态"
                this.Data = {
                    title: '中国心理卫生协会注册心理咨询师（初级）伦理培训课程上线通知',
                    // 2025-12-17 的时间戳（秒）
                    updatetime: Math.floor(new Date('2025-12-17T00:00:00').getTime() / 1000),
                    status_text: '正常',
                    content: `
                        <div style="text-align:center;">
                            <img src="${wenjianImg1}" style="max-width:100%;margin-bottom:10px;" />
                            <img src="${wenjianImg2}" style="max-width:100%;margin-bottom:10px;" />
                            <img src="${wenjianImg3}" style="max-width:100%;margin-bottom:10px;" />
                        </div>
                    `
                };
            } else {
                // 从路由参数读取，根据id和type从API获取数据
                const routeType = this.$route.query.type;
                const routeId = this.$route.query.id;
                
                if (routeType && routeId) {
                    // 有路由参数，根据type和id从API获取数据
                    this.State = routeType;
                    this.fetchDetailById(routeId, routeType);
                } else {
                    // 没有路由参数，显示错误提示
                    this.$message.error("缺少必要的参数，无法获取详情数据");
                }
            }
        },
        methods: {
            // 根据id和type从API获取详情数据
            fetchDetailById(id, type) {
                const routeCategoryId = this.$route.query.category_id;
                let requestPromise;
                let params;
                
                if (type == 5) {
                    // 公告使用POST
                    params = { page: 1, limit: 10000 };
                    requestPromise = this.$post('api/index/noticeList', params);
                } else if (type == 6 && routeCategoryId) {
                    // 信息动态（来自InfoState），使用 information 接口，需要 category_id
                    params = {
                        category_id: routeCategoryId,
                        page: 1,
                        limit: 10000
                    };
                    requestPromise = this.$post('api/index/information', params);
                } else if (type == 7 && routeCategoryId) {
                    // 职业伦理（来自Profession），使用 occupation 接口，需要 category_id
                    params = {
                        category_id: routeCategoryId,
                        page: 1,
                        limit: 10000
                    };
                    requestPromise = this.$post('api/index/occupation', params);
                } else {
                    // 新闻动态使用GET
                    params = { page: 1, limit: 10000 };
                    requestPromise = this.$get('api/index/newsList', params);
                }
                
                requestPromise.then(res => {
                    if (res.data && res.data.code == 1) {
                        const list = res.data.data.data || res.data.data || [];
                        // 从列表中找到对应id的数据
                        const detail = list.find(item => String(item.id) === String(id));
                        if (detail) {
                            // 处理数据字段，确保兼容性
                            const info = { ...detail };
                            if (!info.name && info.title) {
                                info.name = info.title;
                            }
                            if (!info.updatetime && info.createtime) {
                                info.updatetime = info.createtime;
                            }
                            this.Data = info;
                        } else {
                            // 如果API中找不到对应id的数据
                            this.$message.error("未找到对应的详情数据");
                        }
                    } else {
                        // API请求失败
                        this.$message.error((res.data && res.data.msg) || "获取详情数据失败");
                    }
                }).catch(err => {
                    console.error("获取详情失败", err);
                    this.$message.error("获取详情数据失败，请稍后重试");
                });
            },
            Back(){
                this.$router.go(-1)
            },
            OpenLock(res) {
                if(!res) return;
                window.open(this.$Global.CommImgHttp + res)
            },
            getProjectTypeText(type) {
                const map = {
                    '1': '线上',
                    '2': '线下',
                    '3': '线上线下结合',
                    '6': '学历教育',
                    '7': '继续教育'
                };
                return map[String(type)] || '未知';
            },
            formatTime(timestamp) {
                if (!timestamp) return '';
                // 将秒级时间戳转换为毫秒级
                const date = new Date(timestamp * 1000);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            }
        },
        computed:{
            isProjectDetail(){
                return this.Data && this.Data.user_group_id;
            },
            experienceFiles(){
                if(!this.Data || !this.Data.last_experience) return [];
                return this.Data.last_experience.split(',').map(item=>item.trim()).filter(Boolean);
            }
        }
    }
</script>
<style scoped>
    .Page {
        background: #fff;
    }
    
    .BgColorBlue {
        background-color: #037dbe;
    }
    
    .BgColorYellow {
        background-color: #ed8404;
    }
    
    .BgColorGreen {
        background-color: #82ae1d;
    }
    
    .MarTop {
        margin-top: 20px;
    }
    .MaxWid {
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .AboutPos{
        padding: 20px 0;
        font-size: 12px;
        color: #999999;
        cursor: pointer;
    }
    .title{
        padding: 20px 0;
        text-align: center;
        font-size: 18px;
    }
    .ContDis{
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #ddd;
    }
    .ContDis .Flex{
        width: 30%;
        font-size: 14px;
        color: #666;
        padding-bottom:20px;
        text-align: center;
    }
    .ContHead{
        margin: 20px 0;
        width: 100%;
    }
    .project-section{
        margin-top: 20px;
        background: #f8f9fa;
        padding: 20px;
        border-radius: 6px;
    }
    .section-title{
        font-size: 18px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 15px;
        padding-left: 10px;
        border-left: 4px solid #409EFF;
    }
    .info-grid{
        display: grid;
        grid-template-columns: repeat(auto-fit,minmax(200px,1fr));
        gap: 12px;
    }
    .info-item{
        background: #fff;
        border: 1px solid #e6e6e6;
        border-radius: 4px;
        padding: 12px;
    }
    .info-item .label{
        color: #666;
        margin-bottom: 6px;
        font-size: 14px;
    }
    .info-item .value{
        color: #333;
        word-break: break-all;
    }
    .info-block{
        margin-top: 16px;
        background: #fff;
        border: 1px solid #e6e6e6;
        border-radius: 4px;
        padding: 12px;
    }
    .info-block .label{
        color: #666;
        margin-bottom: 6px;
        font-size: 14px;
    }
    .info-block .value{
        color: #333;
        word-break: break-all;
    }
    .file-link{
        color: #409EFF;
        cursor: pointer;
    }
    .experience-files{
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
    }
    .experience-file .LockImg{
        width: 120px;
        height: 120px;
        object-fit: cover;
        border-radius: 4px;
        border: 1px solid #EBEEF5;
        cursor: pointer;
    }
</style>